module.exports = __webpack_public_path__ + "static/media/destination_16_white.93dd1644.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/destination_16_white.svg
// module id = 1407
// module chunks = 0